import React, { useMemo, useRef, useCallback, useState } from 'react';
import { View, Text, FlatList, Image, Dimensions, useWindowDimensions, Animated } from 'react-native';
import { SUB_WIDGET_LIST } from '../../navigation/StackNavigator/routes';
import { useTranslation } from 'react-i18next';
import CustomPressable from '../customPressable/customPressable';
import { ImageComp } from '../Image/Image';
import { useNavigation } from '@react-navigation/native';
import { useCssStyle } from '../../customHook/getCssStyle';
import CustomFlatList from '../customFlatList';
import { getCleanUrl } from '../../utils/Helper';
import RenderHTML from 'react-native-render-html';



const MultipleLargeWidgetScroll = props => {
  const { listItemData, handleOnWidgetClick, widget } = props || {};

  const { t } = useTranslation();
  const { width } = useWindowDimensions()
  const navigation = useNavigation();
  const getStyles = useCssStyle();

  const scrollX = useRef(new Animated.Value(0)).current;
  const [contentWidth, setContentWidth] = useState(0);
  const [containerWidth, setContainerWidth] = useState(0);

  const handleContentSizeChange = useCallback((w) => {
    setContentWidth(w);
  }, []);

  const handleContainerLayout = useCallback((event) => {
    setContainerWidth(event.nativeEvent.layout.width);
  }, []);

  const scrollableWidth = Math.max(contentWidth - containerWidth, 1);
  const thumbWidth = 100;
  const thumbMaxTranslate = containerWidth - thumbWidth;



  const handleListAll = () => {
    navigation.navigate(SUB_WIDGET_LIST, { listItemData, widget })
  }

  const renderItem = ({ item }) => {
    const widgetImg = getCleanUrl(item?.btnImageUrl);
    const listItemDescription = getStyles(['multipleLargeWidget_WidgetsSubTitleText', `multipleLargeWidget_WidgetsSubTitleText_${item.widgetMetaHtmlId}`, `multipleLargeWidget_WidgetsSubTitleText_${item.id}`]);
    return (
        <CustomPressable id={`multipleLargeWidget_WidgetsContainer multipleLargeWidget_WidgetsContainer_${item.widgetMetaHtmlId} multipleLargeWidget_WidgetsContainer_${item.id}`} style={getStyles(['multipleLargeWidget_WidgetsContainer', `multipleLargeWidget_WidgetsContainer_${item.widgetMetaHtmlId}`, `multipleLargeWidget_WidgetsContainer_${item.id}`])} onPress={() => handleOnWidgetClick(item)}>

          <ImageComp
            source={widgetImg}
            style={getStyles(['multipleLargeWidget_WidgetsImg', `multipleLargeWidget_WidgetsImg_${item.widgetMetaHtmlId}`, `multipleLargeWidget_WidgetsImg_${item.id}`])}
            id={`multipleLargeWidget_WidgetsImg multipleLargeWidget_WidgetsImg_${item.widgetMetaHtmlId} multipleLargeWidget_WidgetsImg_${item.id}`}
          />

          <View style={getStyles(['multipleLargeWidget_WidgetsTitleContainer', `multipleLargeWidget_WidgetsTitleContainer_${item.widgetMetaHtmlId}`, `multipleLargeWidget_WidgetsTitleContainer_${item.id}` ])} id={`multipleLargeWidget_WidgetsTitleContainer multipleLargeWidget_WidgetsTitleContainer_${item.widgetMetaHtmlId} multipleLargeWidget_WidgetsTitleContainer_${item.id}`} >

            {item?.widgetTitle && <Text style={getStyles(['multipleLargeWidget_WidgetsTitleText', `multipleLargeWidget_WidgetsTitleText_${item.widgetMetaHtmlId}`, `multipleLargeWidget_WidgetsTitleText_${item.id}` ])} id={`multipleLargeWidget_WidgetsTitleText multipleLargeWidget_WidgetsTitleText_${item.widgetMetaHtmlId} multipleLargeWidget_WidgetsTitleText_${item.id}`} >{item?.widgetTitle}</Text>}

            {item?.widgetDesc && 
            <RenderHTML 
              contentWidth={width}
              baseStyle={listItemDescription}
              source={{ html: item?.widgetDesc }}
              systemFonts={[listItemDescription.fontFamily]}
              id={`multipleLargeWidget_WidgetsSubTitleText multipleLargeWidget_WidgetsSubTitleText_${item.widgetMetaHtmlId} multipleLargeWidget_WidgetsSubTitleText_${item.id}`}
            />}
            {item.buttonTitle &&
              <View onPress={()=> handleOnWidgetClick(item)} style={getStyles(['multipleLargeWidget_WidgetsButtonContainer', `multipleLargeWidget_WidgetsButtonContainer_${item.widgetMetaHtmlId}`, `multipleLargeWidget_WidgetsButtonContainer_${item.id}`])} id={`multipleLargeWidget_WidgetsButtonContainer multipleLargeWidget_WidgetsButtonContainer_${item.widgetMetaHtmlId} multipleLargeWidget_WidgetsButtonContainer_${item.id}`} >
                <RenderHTML
                  contentWidth={width}
                  baseStyle={customWidgetButtonTitleStyle}
                  source={{html: item.buttonTitle}}
                  systemFonts={[customWidgetButtonTitleStyle.fontFamily]}
                />
              </View>
            }
          </View>
        </CustomPressable>
    )
  }

  const customWidgetTitleStyle = useMemo(() => {
      const style = getStyles(['multipleLargeWidgetTitleText', `multipleLargeWidgetTitleText_${listItemData[0]?.widgetMetaHtmlId}`, `multipleLargeWidgetTitleText_${listItemData[0]?.id}`]);
      return Array.isArray(style) ? Object.assign({}, ...style) : style || {};

      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const customWidgetDescriptionStyle = useMemo(() => {
      const style = getStyles(['multipleLargeWidgetDescriptionText', `multipleLargeWidgetDescriptionText_${listItemData[0]?.widgetMetaHtmlId}`, `multipleLargeWidgetDescriptionText_${listItemData[0]?.id}`]);
      return Array.isArray(style) ? Object.assign({}, ...style) : style || {};

      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const customWidgetButtonTitleStyle = useMemo(() => {
      const style = getStyles(['multipleLargeWidget_WidgetsButtonContainerText', `multipleLargeWidget_WidgetsButtonContainerText_${listItemData[0]?.widgetMetaHtmlId}`, `multipleLargeWidget_WidgetsButtonContainerText_${listItemData[0]?.id}`]);
      return Array.isArray(style) ? Object.assign({}, ...style) : style || {};

      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <View style={getStyles(['multipleLargeWidgetContainer', `multipleLargeWidgetContainer_${listItemData[0]?.widgetMetaHtmlId}`])} id={`multipleLargeWidgetContainer multipleLargeWidgetContainer_${listItemData[0]?.widgetMetaHtmlId}`}>

      <View style={getStyles(['multipleLargeWidgetTitleContainer', `multipleLargeWidgetTitleContainer_${listItemData[0]?.widgetMetaHtmlId}`, `multipleLargeWidgetTitleContainer_${listItemData[0]?.id}`])} id={`multipleLargeWidgetTitleContainer multipleLargeWidgetTitleContainer_${listItemData[0]?.widgetMetaHtmlId} multipleLargeWidgetTitleContainer_${listItemData[0]?.id}`}>
        <View style={getStyles(['multipleLargeWidgetTextContainer', `multipleLargeWidgetTextContainer_${listItemData[0]?.widgetMetaHtmlId}`, `multipleLargeWidgetTextContainer_${listItemData[0]?.id}`])} id={`multipleLargeWidgetTextContainer multipleLargeWidgetTextContainer_${listItemData[0]?.widgetMetaHtmlId} multipleLargeWidgetTextContainer_${listItemData[0]?.id}`}>
          {widget?.displayName && <RenderHTML
              contentWidth={width}
              baseStyle={customWidgetTitleStyle}
              source={{ html: widget?.displayName}}
              systemFonts={[customWidgetTitleStyle.fontFamily]}
              id={`multipleLargeWidgetTitleText multipleLargeWidgetTitleText_${listItemData[0]?.widgetMetaHtmlId} multipleLargeWidgetTitleText_${listItemData[0]?.id}`}
          />}
          {widget?.widgetDesc && <RenderHTML
            contentWidth={width}
            baseStyle={customWidgetDescriptionStyle}
            source={{ html: widget?.widgetDesc}}
            systemFonts={[customWidgetDescriptionStyle.fontFamily]}
            id={`multipleLargeWidgetDescriptionText multipleLargeWidgetDescriptionText_${listItemData[0]?.widgetMetaHtmlId} multipleLargeWidgetDescriptionText_${listItemData[0]?.id}`}
          />}
        </View>
        <CustomPressable onPress={handleListAll} style={getStyles(['multipleLargeWidgetViewAll', `multipleLargeWidgetViewAll_${listItemData[0]?.widgetMetaHtmlId}`, `multipleLargeWidgetViewAll_${listItemData[0]?.id}`])} id={`multipleLargeWidgetViewAll multipleLargeWidgetViewAll_${listItemData[0]?.widgetMetaHtmlId} multipleLargeWidgetViewAll_${listItemData[0]?.id}`} >
          <Text style={getStyles(['multipleLargeWidgetViewAllTxt', `multipleLargeWidgetViewAllTxt_${listItemData[0]?.widgetMetaHtmlId}`, `multipleLargeWidgetViewAllTxt_${listItemData[0]?.id}`])} id={`multipleLargeWidgetViewAllTxt multipleLargeWidgetViewAllTxt_${listItemData[0]?.widgetMetaHtmlId} multipleLargeWidgetViewAllTxt_${listItemData[0]?.id}`} >{t('home_page.view_all')}</Text>
        </CustomPressable>
        
        {widget?.widgetHeaderImageUrl && 
          <View style={getStyles(['multipleLargeWidgetImageContainer', `multipleLargeWidgetImageContainer_${widget.id}`])} id={`multipleLargeWidgetImageContainer multipleLargeWidgetImageContainer_${widget.id}`}>
            <ImageComp
              source={getCleanUrl(widget?.widgetHeaderImageUrl)}
              style={getStyles(['multipleLargeWidgetImage', `multipleLargeWidgetImage_${widget.id}`])}
              id={`multipleLargeWidgetImage multipleLargeWidgetImage_${widget.id}`}
            />
          </View>
          }

      </View>

      <CustomFlatList
        data={listItemData}
        renderItem={renderItem}
        contentContainerStyle={getStyles(['multipleLargeWidget_MainWidgetsContainer', `multipleLargeWidget_MainWidgetsContainer_${listItemData[0]?.widgetMetaHtmlId}`, `multipleLargeWidget_MainWidgetsContainer_${listItemData[0]?.id}`])}
        id={`multipleLargeWidget_MainWidgetsContainer multipleLargeWidget_MainWidgetsContainer_${listItemData[0]?.widgetMetaHtmlId}, multipleLargeWidget_MainWidgetsContainer_${listItemData[0]?.id}`}
        keyExtractor={item => item?.widgetId}
        horizontal
        showsHorizontalScrollIndicator={false}
        onLayout={handleContainerLayout}
        onScroll={Animated.event(
          [{ nativeEvent: { contentOffset: { x: scrollX } } }],
          { useNativeDriver: false }
        )}
        scrollEventThrottle={16}
        onContentSizeChange={handleContentSizeChange}
      />

      {/* Progress scrollbar */}
      <View
        style={getStyles(['multipleLargeWidget_ScrollTrack', `multipleLargeWidget_ScrollTrack_${listItemData[0]?.widgetMetaHtmlId}`])}
        id={`multipleLargeWidget_ScrollTrack multipleLargeWidget_ScrollTrack_${listItemData[0]?.widgetMetaHtmlId}`}
      >
        <Animated.View
          style={getStyles([
            'multipleLargeWidget_ScrollThumb',
            {
              width: thumbWidth,
              transform: [{
                translateX: scrollX.interpolate({
                  inputRange: [0, scrollableWidth],
                  outputRange: [0, thumbMaxTranslate],
                  extrapolate: 'clamp',
                }),
              }],
            },
          ])}
        />
      </View>
    </View>
  );
};

export default React.memo(MultipleLargeWidgetScroll);